export const MinusIcon = (props) => {
    const { width = 32, height = 32, className = '' } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            class={className}
            height={height}
            fill="none"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 32 32"
        >
            <path
                fill="currentColor"
                d="M26.4 15.01c-.02.01-2.16.03-4.78.03-5.9.01-7 .04-12.13.32-2.02.12-2.96.17-3.7.2l-2.9.17c-.54.05-.89.17-.89.33 0 .1.14.26.23.27l.12.03.16.04c.04 0 .28.07.53.15 1.27.4 3.4.6 7.47.7a197.68 197.68 0 0 1 8.8.35c5.6.35 6.47.4 7.69.4.62 0 .74 0 .95-.06.28-.07.74-.27 1.07-.48.44-.27.9-.74.9-.92 0-.02.01-.07.04-.12a.67.67 0 0 0 0-.48c-.1-.18-.33-.34-.84-.57-.79-.37-.72-.36-1.79-.37l-.94.01Z"
            />
        </svg>
    );
};
